export default "__VITE_ASSET__DadRMn9I__ 720w";